<div
    class="card-actuation header-actuation your-account m-b-6"
    *ngIf="PendingTasks?.length > 0"
>
    <div
        class="title-height"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <div class="h3 pr-16 cardHeader">Tareas pendientes</div>
    </div>
    <div class="inner-card m-b-5">
        <table id="tbl-pendientes">
            <caption></caption>
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                    <th>Realizada</th>
                </tr>
            </thead>
            <tbody>
                <tr class="pointer m-t-7" *ngFor="let task of PendingTasks">
                    <td>
                        <span>{{ task.tarea }}</span>
                    </td>
                    <td>
                        <span>{{ task.fecha | date: 'dd/MM/yyy' }}</span>
                    </td>
                    <td>
                        <mat-checkbox
                            [checked]="task.checked"
                            (change)="task.checked = !task.checked"
                            class="pending-task-checkbox"
                        ></mat-checkbox>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
